import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";

import Layout from "../../components/Layout";
import UserCreate from "./UserCreate";
import UserList from "./UserList";

const styles = (theme) => ({});

const View = observer(
  class UserScreen extends React.Component {
    constructor(props) {
      super(props);
    }

    render() {
      return (
        <Layout>
          <UserCreate />
          <UserList />
        </Layout>
      );
    }
  }
);

export default withStyles(styles)(View);
